import { ApolloCache } from '@apollo/client';
import ajax from '@client/components/ajax';

type WorkoutsCache = Pick<ApolloCache<unknown>, 'identify' | 'modify'>;

// The upsert rewrites every field, so the saved workout is sent back whole
// with only its type changed. Workouts lists read the workout from Apollo's
// normalized cache, so updating it there shows the rest day at once; the
// caller's reload then only catches up.
export const convertToRestDay = async (
  workoutId: number,
  cache: WorkoutsCache,
) => {
  const workout = await ajax.getWorkout(workoutId);
  const saved = await ajax.upsertWorkout({
    ...workout,
    id: workoutId,
    type: 'rest',
  });
  cache.modify({
    id: cache.identify({ __typename: 'WorkoutTiny', id: workoutId }),
    fields: { type: () => 'rest' },
  });
  return saved;
};

// Apollo hands the cache change to a list's query on a zero-delay timer, and
// holds it back while that query has a request in flight unless it is
// cache-and-network. Reloading at once would hide the rest day until the
// reload lands, so the reload waits one tick, behind Apollo's own timer.
export const reloadAfterCacheUpdate = (reload: () => unknown) =>
  setTimeout(reload, 0);
